import { useState } from "react";
import { Button, ConfigProvider, Form, Input } from "antd";
import { useSearchParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { axios } from "../../../api/axios";
import { config } from "../../../config/config";

export const LoginPage = () => {
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      await axios.post("/auth/login", {
        email: values.email,
        password: values.password,
      });
      window.location.replace(params.get("r") || "/");
    } catch (error: unknown) {
      const responseMessage = (
        error as { response?: { data?: { message?: string } } }
      )?.response?.data?.message;
      const message = responseMessage
        ? responseMessage
        : `Could not reach the API at ${config.api_url}. Start the local server, then try again.`;
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#205496",
          colorTextBase: "#040C15",
          colorBgBase: "#ffffff",
          colorBgContainer: "#ffffff",
          colorBorder: "#d0d5dd",
          fontSize: 16,
        },
      }}
    >
      <div
        style={{
          minHeight: "100vh",
          background: "#07121d",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 420,
            background: "#ffffff",
            color: "#040C15",
            padding: 32,
            borderRadius: 12,
          }}
        >
          <h1 style={{ fontSize: 24, lineHeight: 1.3, color: "#040C15", marginBottom: 8 }}>
            Local test login
          </h1>
          <Toaster />
          <p style={{ fontSize: 14, color: "#344054", marginBottom: 24 }}>
            Signs in against the API on this computer.
          </p>
          {error ? (
            <p style={{ fontSize: 14, color: "#b42318", marginBottom: 16 }}>{error}</p>
          ) : null}
          <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, type: "email" }]}
            >
              <Input autoComplete="username" size="large" />
            </Form.Item>
            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true }]}
            >
              <Input.Password autoComplete="current-password" size="large" />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block size="large">
              Sign in
            </Button>
          </Form>
        </div>
      </div>
    </ConfigProvider>
  );
};
